import { useState, useEffect } from "react";
import { Link } from "react-scroll";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Fleet", to: "services" },
    { label: "Why Us", to: "why-us" },
    { label: "Contact", to: "contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || menuOpen
          ? "bg-black/95 backdrop-blur-md shadow-lg shadow-black/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-24 md:h-28">
          {/* Logo */}
          <Link
            to="hero"
            smooth
            duration={600}
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => setMenuOpen(false)}
          >
            <img
              src="/saraLuxury.png"
              alt="Sagar Luxury Ride"
              className="h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                smooth
                duration={600}
                offset={-112}
                className="text-cream/70 hover:text-gold text-sm tracking-widest uppercase cursor-pointer transition-colors duration-300"
                style={{ letterSpacing: "0.1em" }}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="booking"
              smooth
              duration={600}
              offset={-112}
              className="btn-gold cursor-pointer"
            >
              Book Now
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 focus:outline-none"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span
              className={`hamburger-line ${
                menuOpen ? "rotate-45 translate-y-[7px]" : ""
              }`}
            />
            <span
              className={`hamburger-line ${menuOpen ? "opacity-0 scale-x-0" : ""}`}
            />
            <span
              className={`hamburger-line ${
                menuOpen ? "-rotate-45 -translate-y-[7px]" : ""
              }`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-400 overflow-hidden ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
        style={{ background: "rgba(10,10,10,0.98)" }}
      >
        <div className="px-5 pt-2 pb-6 flex flex-col gap-1 border-t border-white/5">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth
              duration={600}
              offset={-70}
              className="text-cream/70 hover:text-gold py-3 text-sm tracking-widest uppercase cursor-pointer transition-colors duration-300 border-b border-white/5 last:border-0"
              style={{ letterSpacing: "0.1em" }}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="booking"
            smooth
            duration={600}
            offset={-70}
            className="btn-gold cursor-pointer text-center mt-4"
            onClick={() => setMenuOpen(false)}
          >
            Book Now
          </Link>
        </div>
      </div>
    </nav>
  );
}
